import Axios from '../utils/axios-utils';

// create Note
export const createNote = async (data, accountId) => {
    try {
        const response = await Axios.post(`/accounts/${accountId}/notes`, {
            linkedType: data.linkedType,
            linkedId: data.linkedId,
            note: data.note,
        });

        return { success: response.data.status === 'success', data: response.data };
    } catch (error) {
        console.log("Create Note error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Create Note failed" }
        };
    }
};

// update Note
export const updateNote = async (accountId, noteId, data) => {
    try {
        const response = await Axios.patch(`/accounts/${accountId}/notes/${noteId}`, data);
        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Update Note error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Update Note failed" }
        };
    }
};

// delete Note
export const deleteNote = async (accountId, noteId) => {
    try {
        const response = await Axios.delete(`/accounts/${accountId}/notes/${noteId}`);
        return {
            success: response.data.status === 'success',
            data: response.data,
            status: response.status
        };
    } catch (error) {
        console.log("Delete Note error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Delete Note failed" },
            status: error.response?.status || 500
        };
    }
};